import { Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { baseUrl, config } from "../../../services/config";
import { DatePicker } from "antd";
import { Modal, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import Pagination from "@material-ui/lab/Pagination";
import usePagination from "../../../components/usePagination/usePagination";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { upperCase } from "lodash";
import ReactToPrint from "react-to-print";
import AccountVoucherPrint from "../AccountsVocher/AccountVoucherPrint";
import SVG from "react-inlinesvg";
const { RangePicker } = DatePicker;

const ActionReport = () => {
  let authtoken = localStorage.getItem("userToken");
  const alert = useAlert();
  const [loading, setloading] = useState(false);

  const [users, setUsers] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [logReport, setLogReport] = useState([]);
  const [actionType, setActionType] = useState("staff");
  const [user_id, setUserId] = useState("");

  const componentRef = React.useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  const [text, setText] = React.useState("old boring text");
  const [printLoading, setPrintLoading] = React.useState(false);

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const [directorSign, setDirectorSign] = useState(0);

  const [summaryModel, setSummaryModel] = useState(false);
  const [summaryData, setsummaryData] = useState({});
  const [summary, setSummary] = useState({});

  const [selectedvoucher, setselectedvoucher] = useState({});
  const [printvouchermodal, setprintvouchermodal] = useState(false);

  const pageStyle = `
  @page {
    size: A4 portrait !important;
  }
  `;

  useEffect(() => {
    GetAllCampuses();
    getSettingData();
  }, []);

  const GetAllCampuses = async () => {
    await fetch(`${baseUrl}/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((headoffices) => {
        setUsers(headoffices.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
        setDirectorSign(data.payload.settings.director_sign);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchLogs = async () => {
    setloading(true);
    const data = {
      user_id,
      action_type: actionType,
      start_date: selectedDates[0],
      end_date: selectedDates[1],
    };
    await fetch(`${baseUrl}/action-logs/report`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authtoken}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.metadata.success) {
          alert.error(data.metadata.message);
          setloading(false);
        } else {
          if (data.payload.length == 0) {
            alert.error(data.metadata.message);
            setloading(false);
          }
          let res = data.payload;
          let temparr = res;
          res.map((item, index) => {
            item["SrNo"] = index + 1;
            temparr[index] = item;
          });
          setLogReport(temparr);
          setloading(false);
        }
      })
      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  let [page, setPage] = useState(1);
  const PER_PAGE = 20;

  const count = Math.ceil(logReport.length / PER_PAGE);
  const _DATA = usePagination(logReport, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  const todayDate = () => {
    let d = new Date();
    var curr_moth = ("0" + (d.getMonth() + 1)).slice(-2);
    var curr_date = ("0" + d.getDate()).slice(-2);
    let newdate = `${d.getFullYear()}-${curr_moth}-${curr_date}`;
    return newdate;
  };

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setPrintLoading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setPrintLoading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setPrintLoading, setText]);

  const fetxhingSummaryData = (id) => {
    let data = {
      voucher_id: id,
    };

    fetch(`${baseUrl}/voucher_summary`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setSummary(data.payload);
            setsummaryData(data.payload);
            setSummaryModel(true);
          }
        } else {
          setSummaryModel(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  console.log(summaryModel, "summaryModel");
  return (
    <Paper style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}>
      <div className="row">
        <div className="col-md-3">
          <label className="form-label">
            <b>
              Select User <span className="text-danger">*</span>
            </b>
          </label>
          <select
            value={user_id}
            onChange={(e) => setUserId(e.target.value)}
            className="form-select h-40px"
          >
            <option value="">Select User</option>
            {users.map((usr) => (
              <option value={usr.id}>
                {usr.first_name} {usr.last_name}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">
            <b>Select Action Type</b>
          </label>
          <select
            value={actionType}
            onChange={(e) => {
              setActionType(e.target.value);
              setLogReport([]);
            }}
            className="form-select h-40px"
          >
            <option value="staff">Staff</option>
            <option value="student">Student</option>
            <option value="account">Account</option>
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">
            <b>Select Start & End Date</b>
          </label>
          <RangePicker
            className="h-40px"
            onChange={(date, dateString) => setSelectedDates(dateString)}
          />
        </div>

        <div className="col-md-3 mt-9">
          <button onClick={searchLogs} className="btn btn-primary">
            Search Logs
          </button>
        </div>
      </div>

      <>
        {actionType === "student" && (
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">SR.No</th>
                <th className="text-center">User</th>
                <th className="text-center">Student Name</th>
                <th className="text-center">Title</th>
                <th className="text-center">Action</th>
                <th className="text-center">Date</th>
              </tr>
            </thead>
            <tbody>
              {_DATA.currentData().map((report, index) => (
                <tr key={index}>
                  <td className="text-center">{report?.SrNo}</td>
                  <td className="text-center">
                    {report?.user?.first_name + " " + report?.user?.last_name}
                  </td>
                  <td className="text-center">
                    {report?.student?.name} ({report?.student?.admission_id})
                  </td>
                  <td className="text-center">{report?.title}</td>
                  <td className="text-center">{report?.description}</td>
                  <td className="text-center">{report?.date}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {actionType === "staff" && (
          <Table responsive>
            <thead>
              <tr>
                <th className="text-center">SR.No</th>
                <th className="text-center">User</th>
                <th className="text-center">Employe Name</th>
                <th className="text-center">Title</th>
                <th className="text-center">Action</th>
                <th className="text-center">Date</th>
              </tr>
            </thead>
            <tbody>
              {_DATA.currentData().map((report, index) => (
                <tr key={index}>
                  <td className="text-center">{report?.SrNo}</td>
                  <td className="text-center">
                    {report?.user?.first_name + " " + report?.user?.last_name}
                  </td>
                  <td className="text-center">
                    {report?.employee?.full_name} ({report?.employee?.emp_code})
                  </td>
                  <td className="text-center">{report?.title}</td>
                  <td className="text-center">{report?.description}</td>
                  <td className="text-center">{report?.date}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        {actionType === "account" && (
          <Table responsive>
            <thead>
              <tr className="text-center">
                <th>SrNo.</th>
                <th>User</th>
                <th>Voucher Type Name</th>
                <th>Session Year</th>
                <th>Voucher Number</th>
                <th>Summary</th>
                <th>Print</th>
              </tr>
            </thead>

            <tbody>
              {_DATA.currentData().map((item, index) => (
                <tr key={index} className="text-center">
                  <td>{item?.SrNo}</td>
                  <td className="text-center">
                    {item?.user?.first_name + " " + item?.user?.last_name}
                  </td>
                  <td
                    title={
                      item.voucher_type.name.length > 20
                        ? item.voucher_type.name
                        : null
                    }
                    style={{ textAlign: "center", cursor: "pointer" }}
                  >
                    {item.voucher_type.name.length > 20
                      ? item.voucher_type.name.substring(0, 17) + "..."
                      : item.voucher_type.name}
                  </td>
                  <td>{item.session.year}</td>
                  <td>{item.voucher_no}</td>
                  <td>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        fetxhingSummaryData(item.id);
                      }}
                      className="svg-icon svg-icon-md svg-icon-primary-custom"
                    >
                      <SVG src={toAbsoluteUrl("/media/svg/files/doc.svg")} />
                    </span>
                  </td>

                  <td>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setprintvouchermodal(true);
                        setselectedvoucher(item);
                      }}
                      className="svg-icon svg-icon-md svg-icon-primary-custom"
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Devices/Printer.svg"
                        )}
                      />
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}

        <div className="row justify-content-center">
          {loading ? <span className="spinner-border"></span> : null}
        </div>

        <Pagination
          color="text-primary"
          count={count}
          size="large"
          page={page}
          variant="text"
          shape="round"
          onChange={handleChange}
        />

        {/* ///summarymodel */}
        <Modal size="xl" show={summaryModel}>
          <div id="voucher-p">
            <Modal.Body>
              {console.log(summaryData)}
              <div>
                <div className="page1-content">
                  <div
                    style={{
                      display: "flex",
                      padding: "10px",
                    }}
                  >
                    <img
                      src={icon}
                      style={{ height: 100, width: 110 }}
                      alt="icon"
                    />
                    <h3
                      style={{
                        color: "#B4959D",
                        // width: "20%",
                        paddingLeft: "10px",
                        paddingTop: "25px",
                      }}
                    >
                      {unitName}
                    </h3>
                  </div>
                  <hr className="page1-line" />
                  <div className="dataPage1">
                    <div className="detailPage1">
                      <h5>Financial Year :- {summaryData?.session?.year}</h5>
                      <h5>Printing Date :- {todayDate()}</h5>
                      <h5>
                        Printing Time :- {new Date().toLocaleTimeString()}
                      </h5>
                    </div>
                    <div className="voucherDetailPage1">
                      <h5>Voucher No:- {summaryData?.voucher_no}</h5>
                      <h5>Voucher Date:- {summaryData?.date}</h5>
                      {summaryData?.check_no != null ? (
                        <h5>Cheque No:- {summaryData?.check_no} </h5>
                      ) : null}
                    </div>
                  </div>
                  <hr className="page1-line" />
                  <table className="page1-table">
                    <tr className="page1-tr">
                      <th style={{ textAlign: "center" }} className="page1-th">
                        Sr No#
                      </th>
                      <th style={{ textAlign: "center" }} className="page1-th">
                        Acc Code
                      </th>
                      <th style={{ textAlign: "center" }} className="page1-th">
                        Account Name / Description
                      </th>
                      <th style={{ textAlign: "center" }} className="page1-th">
                        Debit
                      </th>
                      <th style={{ textAlign: "center" }} className="page1-th">
                        Credit
                      </th>
                    </tr>
                    {summaryData?.summary_general_ledger?.map((item, index) => {
                      return (
                        <tr className="page1-tr">
                          <td
                            style={{ textAlign: "center" }}
                            className="page1-td"
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{ textAlign: "center" }}
                            className="page1-td"
                          >
                            {item?.sub_account?.acode}
                          </td>
                          <td
                            style={{ textAlign: "center" }}
                            className="page1-td"
                          >
                            {item?.sub_account?.title}
                          </td>
                          <td className="page1-td text-right">
                            {Intl.NumberFormat("en-Us").format(item.debit)}
                          </td>
                          <td className="page1-td text-right">
                            {Intl.NumberFormat("en-Us").format(item.credit)}
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td className="page1-td"></td>
                      <td className="page1-td"></td>
                      <td className="page1-td text-right">
                        <b>Total</b>
                      </td>
                      <td className="page1-td text-right">
                        <b>
                          {Intl.NumberFormat("en-Us").format(
                            summary.total_debit == null
                              ? 0
                              : parseInt(summary.total_debit)
                          )}
                        </b>
                      </td>
                      <td className="page1-td text-right">
                        <b>
                          {Intl.NumberFormat("en-Us").format(
                            summary.total_credit == null
                              ? 0
                              : parseInt(summary.total_credit)
                          )}
                        </b>
                      </td>
                    </tr>
                  </table>
                  <div className="lower-content">
                    <div className="lower1">
                      <div className="lower2">
                        <p>Prepared By</p>
                      </div>
                    </div>
                    <div className="lower1">
                      <div className="lower2">
                        <p>Accountant</p>
                      </div>
                    </div>
                    <div className="lower1" id="lowerLast">
                      <div className="lower2">
                        {directorSign == 0 ? (
                          <p>Chief Executive</p>
                        ) : (
                          <p>Director</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <hr className="page1-line" />
                  <p className="indexNumber1">Page 1 of 1</p>
                </div>
              </div>
            </Modal.Body>
          </div>
          <Modal.Footer>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              {/* <button
               onClick={() => {
                setshow2(true)
              }}
              className="btn btn-success button_blue mx-2"
            >
              Submit
            </button> */}
              <ReactToPrint
                documentTitle="Voucher Summary"
                pageStyle={pageStyle}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printLoading ? true : false}
                    className="btn btn-success button_blue button_blue"
                  >
                    {printLoading ? "Printing..." : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />

              <button
                onClick={() => {
                  setSummaryModel(false);
                }}
                style={{ width: "150px", height: "40px", marginLeft: "10px" }}
                className="btn btn-danger btn_width"
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        {summaryModel && (
          <div style={{ visibility: "hidden" }}>
            <div ref={componentRef} id="printSection">
              <div>
                <div className="page1-content">
                  <div className="d-flex">
                    <img
                      src={icon}
                      style={{ height: 120, width: 110 }}
                      alt="icon"
                    />
                    <div className="col-md-10 pl-5">
                      <h1 style={{ color: `${config.txtColor}` }}>
                        {unitName}
                      </h1>
                      <h3 style={{ color: `${config.txtColor}` }}>
                        Account Voucher Summary
                      </h3>
                    </div>
                  </div>

                  <div
                    className="d-flex justify-content-between"
                    style={{ margin: "15px 0" }}
                  >
                    <div>
                      <h3 style={{ fontSize: "19px" }}>
                        Financial Year :- {summaryData?.session?.year}
                      </h3>
                      <h3 style={{ fontSize: "19px" }}>
                        Printing Date :- {todayDate()}
                      </h3>
                      <h3 style={{ fontSize: "19px" }}>
                        Printing Time :- {new Date().toLocaleTimeString()}
                      </h3>
                    </div>
                    <div>
                      <h3 style={{ fontSize: "19px" }}>
                        Voucher No:- {summaryData?.voucher_no}
                      </h3>
                      <h3 style={{ fontSize: "19px" }}>
                        Voucher Date:- {summaryData?.date}
                      </h3>
                      {summaryData?.check_no != null ? (
                        <h3 style={{ fontSize: "19px" }}>
                          Cheque No:- {summaryData?.check_no}{" "}
                        </h3>
                      ) : null}
                    </div>
                  </div>

                  <table
                    className="page1-table"
                    style={{
                      whiteSpace: "normal",
                      padding: "1px",
                      marginTop: "20px",
                      color: "black",
                    }}
                  >
                    <tr
                      className="page1-tr"
                      style={{ whiteSpace: "normal", padding: "1px" }}
                    >
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-th"
                      >
                        Sr No#
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-th"
                      >
                        Acc Code
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-th"
                      >
                        Account Name / Description
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-th"
                      >
                        Debit
                      </th>
                      <th
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                        className="page1-th"
                      >
                        Credit
                      </th>
                    </tr>
                    {summaryData?.summary_general_ledger?.map((item, index) => {
                      return (
                        <tr
                          className="page1-tr"
                          style={{ whiteSpace: "normal", padding: "1px" }}
                        >
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              whiteSpace: "normal",
                              padding: "1px",
                            }}
                            className="page1-td"
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              whiteSpace: "normal",
                              padding: "1px",
                            }}
                            className="page1-td"
                          >
                            {item?.sub_account?.acode}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              whiteSpace: "normal",
                              padding: "1px",
                            }}
                            className="page1-td"
                          >
                            {item?.sub_account?.title}
                          </td>
                          <td
                            className="page1-td text-center"
                            style={{
                              fontSize: "20px",
                              whiteSpace: "normal",
                              padding: "1px",
                            }}
                          >
                            {Intl.NumberFormat("en-Us").format(item.debit)}
                          </td>
                          <td
                            className="page1-td text-center"
                            style={{
                              fontSize: "20px",
                              whiteSpace: "normal",
                              padding: "1px",
                            }}
                          >
                            {Intl.NumberFormat("en-Us").format(item.credit)}
                          </td>
                        </tr>
                      );
                    })}
                    <tr style={{ whiteSpace: "normal", padding: "1px" }}>
                      <td
                        className="page1-td"
                        style={{ whiteSpace: "normal", padding: "1px" }}
                      ></td>
                      <td
                        className="page1-td"
                        style={{ whiteSpace: "normal", padding: "1px" }}
                      ></td>
                      <td
                        className="page1-td text-center"
                        style={{
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        <b>Total</b>
                      </td>
                      <td
                        className="page1-td text-center"
                        style={{
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        <b>
                          {Intl.NumberFormat("en-Us").format(
                            summary.total_debit == null
                              ? 0
                              : parseInt(summary.total_debit)
                          )}
                        </b>
                      </td>
                      <td
                        className="page1-td text-center"
                        style={{
                          fontSize: "20px",
                          whiteSpace: "normal",
                          padding: "1px",
                        }}
                      >
                        <b>
                          {Intl.NumberFormat("en-Us").format(
                            summary.total_credit == null
                              ? 0
                              : parseInt(summary.total_credit)
                          )}
                        </b>
                      </td>
                    </tr>
                  </table>
                  <div className="lower-content">
                    <div className="lower1">
                      <div className="lower2">
                        <p style={{ fontSize: "20px" }}>Prepared By</p>
                      </div>
                    </div>
                    <div className="lower1">
                      <div className="lower2">
                        <p style={{ fontSize: "20px" }}>Accountant</p>
                      </div>
                    </div>
                    <div className="lower1" id="lowerLast">
                      <div className="lower2">
                        {directorSign == 0 ? (
                          <p style={{ fontSize: "20px" }}>Chief Executive</p>
                        ) : (
                          <p style={{ fontSize: "20px" }}>Director</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* print voucher */}
        {printvouchermodal && (
          <AccountVoucherPrint
            show={printvouchermodal}
            onHide={() => {
              setprintvouchermodal(false);
            }}
            selectedVoucher={selectedvoucher}
            reload={() => searchLogs()}
          />
        )}
      </>
    </Paper>
  );
};

export default ActionReport;
